/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AlertNotificationSetting } from '../../models/alert-notification-setting';

export interface GetSetting_3$Params {
  settingId: number;
}

export function getSetting_3(http: HttpClient, rootUrl: string, params: GetSetting_3$Params, context?: HttpContext): Observable<StrictHttpResponse<AlertNotificationSetting>> {
  const rb = new RequestBuilder(rootUrl, getSetting_3.PATH, 'get');
  if (params) {
    rb.path('settingId', params.settingId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AlertNotificationSetting>;
    })
  );
}

getSetting_3.PATH = '/api/notification/alert/setting/id/{settingId}';
